module.exports = __webpack_public_path__ + "img/style-01.8d5b50b2.png";